import type { EvaluationType, SavedFilter } from '@schooly/api';
import { FilterKeys, FilterSection, GroupType } from '@schooly/api';
import { isNotEmpty } from '@schooly/utils/predicates';

import { MarkbookFilterForm } from './MarkbookFilterContext';

export const filterToForm = (
  filter: Omit<SavedFilter['filter'], 'name'> & { name: string },
): Partial<MarkbookFilterForm> => {
  const date = filter[FilterKeys.Date] || [];
  const age_group = filter[FilterKeys.AgeGroup] || [];
  const subject = filter[FilterKeys.Subject] || [];
  const group = filter[FilterKeys.Group] || [];
  const evaluation_type = filter[FilterKeys.EvaluationType] || [];
  const area_of_learning = filter[FilterKeys.AreaOfLearning] || [];
  const assessment = filter[FilterKeys.Assessment] || [];
  const tutor_group = filter[FilterKeys.GroupTypes]?.includes(GroupType.TutorGroup) || false;

  return {
    name: filter.name,
    date: date.length >= 2 ? ([String(date[0]), String(date[1])] as [string, string]) : ['', ''],
    age_group: age_group.map(String),
    subject: subject.map(String),
    group: group.map(String),
    aol_evaluation_type: [area_of_learning.map(String), evaluation_type.map(Number)],
    assessment_ids: assessment.length > 0 ? assessment.map(String) : [],
    group_type: group.length > 0 ? FilterKeys.Group : FilterKeys.AgeGroup,
    selectedAssessmentIds: assessment.length > 0 ? new Set(assessment.map(String)) : new Set([]),
    tutor_group,
  };
};

export const formToFilter = (
  formData: MarkbookFilterForm,
  isDefault = false,
): Omit<SavedFilter, 'id'> => {
  const {
    date,
    age_group,
    subject,
    group,
    aol_evaluation_type,
    assessment_ids,
    name,
    group_type,
    tutor_group,
  } = formData;
  const evaluation_type = aol_evaluation_type[1] as EvaluationType[];
  const area_of_learning = aol_evaluation_type[0] as string[];

  const group_types = [
    subject.length > 0 ? GroupType.Subject : null,
    tutor_group ? GroupType.TutorGroup : null,
  ].filter(isNotEmpty);

  return {
    name,
    section: FilterSection.Markbook,
    is_default: isDefault,
    filter: {
      [FilterKeys.Date]: date.filter(Boolean),
      [FilterKeys.AgeGroup]: group_type === FilterKeys.AgeGroup ? age_group : [],
      [FilterKeys.Subject]: subject,
      [FilterKeys.Group]: group_type === FilterKeys.Group ? group : [],
      [FilterKeys.EvaluationType]: evaluation_type,
      [FilterKeys.AreaOfLearning]: area_of_learning,
      [FilterKeys.Assessment]: assessment_ids,
      [FilterKeys.GroupTypes]: group_types,
    },
  };
};
